import React, {useEffect, useState} from "react";
import DataTable from "../../../components/data-table";
import Breadcrumbs from "../../../components/breadcrumbs";
import {useDispatch, useSelector} from "react-redux";
import {useHistory} from "react-router-dom";
import Button from "../../../components/button";
import Modal from "../../../components/modal";
import Input from "../../../components/input";
import LoadingSpinner from '../../../components/loading-spinner';
import {Switch, Space} from "antd";

import {
    getAllResultStates,
    clear_result_states,
    createResultState,
    CREATE_RESULT_STATE,
    updateResultState,
    UPDATE_RESULT_STATE
} from "../../../redux/result_states";
import {ToastContainer, toast} from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import Footer from "../../../components/footer";

const ResultStates = (props) => {
    let history = useHistory();
    let dispatch = useDispatch();

    const {token} = useSelector((state) => state.users_module.login.data) || null;

    const _get_all_result_states = useSelector((state) => state.result_states_module._get_all_result_states);
    const _create_result_state = useSelector((state) => state.result_states_module._create_result_state);
    const _update_result_state = useSelector((state) => state.result_states_module._update_result_state);

    const [data, setData] = useState([]);

    useEffect(() => {
        if (_get_all_result_states.data.datos) {
            setData(_get_all_result_states.data.datos);
        }
    }, [_get_all_result_states]);

    const [permisos, setPermisos] = useState([]);
    const [actions, setActions] = useState([]);
    const [modal, setModal] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [id, setId] = useState(0);

    const [form, setForm] = useState({
        nombre: "",
        color: "",
        activo: true,
        defecto: false,
        calcular: false,
        campo_obligatorio: false,
    });

    useEffect(() => {
        if (props) {
            const array = Object.values(props);
            setPermisos(array);
        }
    }, [props]);

    useEffect(() => {
        let act = []
        if (permisos) {
            if (permisos.filter(x => x.codigo === 'change_resultstates').length > 0) {
                act.push({
                    name: "edit",
                    label: "Edit",
                    icon: "bx bx-edit",
                    color: "calendar",
                    onClick: (item) => {
                        setModal(true);
                        setId(item.id);
                        setForm({
                            ...form, 
                            nombre: item.nombre, 
                            color: item.color, 
                            activo: item.activo,
                            defecto: item.defecto,
                            calcular: item.calcular,
                            campo_obligatorio: item.campo_obligatorio
                        });
                    },
                })
            }
        }
        setActions(act);
        // eslint-disable-next-line
    }, [permisos, history]);

    const handleChange = (e) => {
        setForm({
            ...form,
            [e.target.name]: e.target.value,
        });
    };

    const handleCheckedChange = (checked) => {
        setForm({
            ...form,
            activo: checked,
        });
    };

    const handleCheckedChangeCalculate = (checked) => {
        setForm({
            ...form,
            calcular: checked,
        });
    };
    
    const handleCheckedChangeRequiredField = (checked) => {
        setForm({
            ...form,
            campo_obligatorio: checked,
        });
    };

    const handleCheckedChangeDefault = (checked) => {
        setForm({
            ...form,
            defecto: checked,
        });
    };

    useEffect(() => {
        if (_create_result_state.status === 201) {
            toast.success("Creado correctamente", {position: toast.POSITION.TOP_RIGHT});
            dispatch(clear_result_states(CREATE_RESULT_STATE));
            dispatch(getAllResultStates(token));
            setIsLoading(false);
            setModal(false);
        } else if (_create_result_state.status !== 0) {
            dispatch(clear_result_states(CREATE_RESULT_STATE));
            toast.error(_create_result_state.message, {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
        }
    }, [_create_result_state, dispatch, history, token, id]);

    useEffect(() => {
        if (_update_result_state.status === 200) {
            toast.success("Actualizado correctamente", {position: toast.POSITION.TOP_RIGHT});
            dispatch(clear_result_states(UPDATE_RESULT_STATE));
            dispatch(getAllResultStates(token));
            setIsLoading(false);
            setModal(false);
            setId(0);
        } else if (_update_result_state.status !== 0) {
            dispatch(clear_result_states(UPDATE_RESULT_STATE));
            toast.error(_update_result_state.message, {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
        }
    }, [_update_result_state, dispatch, history, token, id]);

    const handleSubmit = (e) => {
        e.preventDefault();
        setIsLoading(true);
        if (form.nombre === "") {
            toast.error("Debe ingresar el nombre", {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
            return;
        }
        if (id === 0) {
            dispatch(createResultState(token, form));
        } else {
            dispatch(updateResultState(token, id, form));
        }
    };

    return (
        <div className="app-content content">
            <div className="content-overlay"/>

            <div className="content-wrapper">
                <div className="content-header row">
                    <div className="content-header-left col-12 mb-2 mt-1">
                        <Breadcrumbs
                            title="Lista"
                            items={[{label: "Resultado de estados", link: "/resultados-estados"}]}
                        />
                    </div>
                </div>
                <div className="content-body">
                    <div><ToastContainer/></div>
                    <div className="card">
                        <div className="card-content">
                            <div className="card-body">
                                {
                                    permisos.filter(x => x.codigo === 'add_resultstates').length > 0 ?
                                        <Button type="button" text="Crear" theme="calendar" onClick={() => {
                                            setModal(true);
                                            setForm({
                                                ...form, 
                                                nombre: '', 
                                                color: '', 
                                                activo: true,
                                                defecto: false,
                                                calcular: false
                                            });
                                            setId(0);
                                        }}/> : null
                                }
                                <div className="table-responsive">
                                    <DataTable
                                        dataTable={data}
                                        columns={[
                                            {
                                                name: "fecha_creacion",
                                                label: "Fecha de creación",
                                                type: "text",
                                            },
                                            {
                                                name: "nombre",
                                                label: "Nombre",
                                                type: "text",
                                            },
                                            {
                                                name: "color",
                                                label: "Color",
                                                type: "text",
                                            },
                                            {
                                                name: "activo",
                                                label: "Activo",
                                                type: "boolean",
                                            },
                                            {
                                                name: "calcular",
                                                label: "Calcular",
                                                type: "boolean",
                                            },
                                            {
                                                name: "defecto",
                                                label: "Defecto",
                                                type: "boolean",
                                            },
                                            {
                                                name: "campo_obligatorio",
                                                label: "Campo obligatorio",
                                                type: "boolean",
                                            },
                                        ]}
                                        actions={actions}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Modal className="modal-main div-modal" show={modal}>
                <form onSubmit={handleSubmit}>
                    {isLoading && <LoadingSpinner/>}
                    <div className="card-body">
                        <h5 className="titulo_modal type_text mb-2">{id === 0 ? 'Crear ' : 'Editar '} resultado de estado</h5>
                        <div className="form-group">
                            <Input
                                label="Nombre"
                                name="nombre"
                                value={form.nombre}
                                onChange={handleChange}
                            />
                        </div>
                        <div className="form-group">
                            <Input
                                label="Color"
                                name="color"
                                value={form.color}
                                onChange={handleChange}
                            />
                        </div>
                        <div className="form-group">
                            <Space size={14} direction='horizontal'>
                                <strong>Por defecto</strong>
                                <Switch
                                    checked={form.defecto}
                                    checkedChildren="SI"
                                    unCheckedChildren="NO"
                                    onChange={handleCheckedChangeDefault}
                                />
                            </Space>
                        </div>
                        <div className="form-group">
                            <Space size={14} direction='horizontal'>
                                <strong>Calcular</strong>
                                <Switch
                                    checked={form.calcular}
                                    checkedChildren="SI"
                                    unCheckedChildren="NO"
                                    onChange={handleCheckedChangeCalculate}
                                />
                            </Space>
                        </div>
                        <div className="form-group">
                            <Space size={14} direction='horizontal'>
                                <strong>Campo obligatorio</strong>
                                <Switch
                                    checked={form.campo_obligatorio}
                                    checkedChildren="SI"
                                    unCheckedChildren="NO"
                                    onChange={handleCheckedChangeRequiredField}
                                />
                            </Space>
                        </div>
                        {id !== 0 &&
                            <div className="form-group">
                                <Space size={14} direction='horizontal'>
                                    <strong>Activo</strong>
                                    <Switch
                                        checked={form.activo}
                                        checkedChildren="SI"
                                        unCheckedChildren="NO"
                                        onChange={handleCheckedChange}
                                    />
                                </Space>
                            </div>
                        }
                    </div>
                    <div className="card-footer text-center">
                        <button disabled={isLoading} onClick={() => {
                        }} className={`btn btn-calendar mb-1 button_div`}>Guardar
                        </button>
                        <button type="button" onClick={() => {
                            setModal(false);
                        }} className={`btn btn-outline-calendar button_div`}>Cancelar
                        </button>
                    </div>
                </form>
            </Modal>
            <Footer/>
        </div>
    );
};

export default ResultStates;
